import SocialSecurityContributionViewComponent from "../components/SocialSecurityContributionView";
import useSocialSecurityContributionView from "../hooks/useSocialSecurityContributionView";

const SocialSecurityContributionView = (props) => {
  const socialSecurityContributionViewProps = useSocialSecurityContributionView(props);
  return <SocialSecurityContributionViewComponent {...socialSecurityContributionViewProps} />;
};

export default SocialSecurityContributionView;
